<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			setRem() {
				var html = document.querySelector('html');
				html.style.fontSize = html.offsetWidth / 7.5 + "px";
			}
		},
		created() {
			this.setRem()
		},
		mounted() {
			// 改变窗口大小时重新设置 rem
			window.onresize = () => {
				this.setRem()
			}
		}
	}
</script>

<style lang="scss">
</style>
